<div class="message-container">
  <div class="message">
    Your details are being verified. You will be redirect once the verification
    is completed.
  </div>
</div>
